<div
  class="toolbar-context-menu"
  [ngStyle]="{
    top: (position?.y ?? 0) + 'px',
    left: (position?.x ?? 0) + 'px'
  }"
>
  <ng-content></ng-content>
</div>
